export default {
  settings: {
    title: '設定',
    account_related: 'アカウント関連',
    user_related: 'ユーザー関連',
    add_user_title: 'ユーザー追加',
    edit_user_title: 'ユーザー編集',
    label: {
      enabled: 'あり',
      not_set: '未設定',
    },
    company: {
      title: '企業情報',
      name: '会社名',
      english_name: 'English name',
      scale: '従業員数',
      industry_type: '業種',
      plan: 'プラン',
      location: '住所',
      allowed_ip: 'IPアドレス制限',
      mfa: 'SMS認証',
      sales_amount: '売上高',
      country: '国',
    },
    contract_plans: {
      buyer: 'バイヤープラン',
      supplier: 'サプライヤープラン',
    },
    contents: {
      title: 'コンテンツ',
      manual_with_brackets: 'マニュアル（{content}）',
    },
    user: {
      title: 'ユーザー',
      name: '氏名',
      first_name: '名',
      last_name: '姓',
      email: 'メールアドレス',
      email_unverified: '疎通前',
      password: 'パスワード',
      password_protection: 'セキュリティ保護のため表示していません',
      phone_number: '電話番号',
      role: {
        title: '権限',
        admin: '管理者',
        general: '一般',
      },
      locale: '言語選択',
      action: '操作',
      total: '全{total}件 (最大{max}件)',
    },
    button: {
      create: 'ユーザー追加',
      edit: '@:common.btn.edit',
      cancel: '@:common.btn.cancel',
      close: '@:common.btn.close',
      add: '@:common.btn.add',
      update: '更新する',
      delete: '@:common.btn.delete',
      do_delete: '削除する',
      reset_password: '@:forgot_password.title',
    },
    cautions_title: '【ご注意】',
    cautions_01: 'メールアドレスの変更はできません。メールを再設定いただくには、新たにユーザーを作成してください。',
    cautions_02: '電話番号はSMS認証が設定されている場合、必須となります。',
    cautions_03: 'パスワードリセットは、登録メールアドレスに送信された確認コードをパスワード再設定画面に入力して実施してください。',
    cautions_04: 'ユーザー削除しても、回答したデータやスコアカードは削除されません。',
    messages: {
      user_update: 'ユーザー情報を更新する',
      user_delete: 'ユーザーを削除する',
      confirm_delete: 'このユーザーを削除しますか？',
      complete_create: 'ユーザー情報の追加が完了しました。',
      complete_update: 'ユーザー情報の更新が完了しました。',
      complete_delete: 'ユーザー情報の削除が完了しました。',
      disabled_delete: '管理者がいなくなるため\n削除できません',
      disabled_delete_by_auth: '管理者のみ削除できます',
      invalid_form: '入力内容に不備があります。',
      caution_title: '@:list_table_filter.csv_modal_cautionary_note_title',
      caution_one: '「追加」をクリックすると、入力したメールアドレスに確認メールが送信されます。\n　その後、ログインIDとパスワードが記載されたメールが送信されます。',
      caution_two: '電話番号はSMS認証が設定されている場合、必須となります。',
      caution_three: 'ユーザーは最大5名まで追加可能です。',
      user_add_title: 'ユーザーを追加する',
      user_add_message_one: '入力いただいたメールアドレスへ、メールをお送りしました。',
      user_add_message_two: 'ご確認いただき、メール内容に従ってログインしてください。',
    },
    tips: {
      role: '「管理者」権限はユーザーの追加や削除ができますが、「一般」権限ではできません。',
      locale: 'ログイン後に初期設定で表示される言語を選択できます。',
    },
    english_name_edit_modal_title: 'English name を設定する',
    english_name_input_label: 'English name',
    english_name_placeholder: 'English name を入力してください',
    reset_password: {
      title: '@:forgot_password_submit.title',
      content: 'ログアウトして、パスワード再設定画面に遷移してもよろしいですか？パスワード再設定画面では、登録されたメールアドレスにお送りしたメールに記載された確認コードを入力してください。',
      reset: 'リセットする',
    },
  },
}
